import {useAppSelector} from '@/hooks';

export const useGetCurrentPageOrder = (): number | undefined => {
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });
  const currentPageOrder = useAppSelector((state) => {
    return state.posterEditor?.posterObject?.pages.pageOrder;
  });

  if (!currentPageOrder?.length) {
    return undefined;
  }

  const pageOrder = currentPageOrder.indexOf(currentPageId);
  return pageOrder !== -1 ? pageOrder : undefined;
};
